import { render, staticRenderFns } from "./TagsSectionCard.vue?vue&type=template&id=1ce1a7ae&"
import script from "./TagsSectionCard.vue?vue&type=script&lang=js&"
export * from "./TagsSectionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports